import React from "react";
import { formatPrice } from "../utils/pricing";

/** Order summary value for the weight-based delivery fee, with loading and retry states. */
const DeliveryFeeAmount = ({ fee, status, onRetry, className = "" }) => {
  if (status === "ready") {
    return (
      <span className={`text-gray-900 ${className}`}>
        LKR {formatPrice(fee)}
      </span>
    );
  }

  if (status === "loading") {
    return (
      <span
        className={`d-inline-flex align-items-center gap-6 text-gray-500 ${className}`}
        role="status"
      >
        <span
          className="spinner-border"
          style={{ width: "0.875rem", height: "0.875rem", borderWidth: "0.15em" }}
          aria-hidden="true"
        />
        Calculating…
      </span>
    );
  }

  return (
    <span className={`d-inline-flex align-items-center gap-8 ${className}`}>
      <span className="text-danger-600">Unavailable</span>
      <button
        type="button"
        onClick={onRetry}
        className="d-inline-flex align-items-center gap-4 p-0 border-0 bg-transparent text-main-600 text-xs fw-semibold hover-text-decoration-underline"
      >
        <i className="ph ph-arrow-clockwise" aria-hidden="true" />
        Retry
      </button>
    </span>
  );
};

export default DeliveryFeeAmount;
